import { render, staticRenderFns } from "./ReturnGoodsShowSection.vue?vue&type=template&id=70e7c347"
import script from "./ReturnGoodsShowSection.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsShowSection.vue?vue&type=script&lang=js"
import style0 from "./ReturnGoodsShowSection.vue?vue&type=style&index=0&id=70e7c347&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports